import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Skeleton } from 'native-base';
import React from 'react';

import { ManagementFeeStatus } from '../../../../../store/rateManagement/constants';

import { MasterAccountField } from './MasterAccountField';

import { CardTypes } from '.';

export const CardDesktop: React.FC<CardTypes.Props> = ({ loading, sentOrderDetail }) => {
  const skeletons = (
    <VStack alignItems="center" w="100%" space={Spacing['stack.quarck']}>
      <HStack
        paddingBottom={Spacing['stack.quarck']}
        justifyContent="space-between"
        width="100%"
        space={Spacing['stack.quarck']}>
        {Array.from({ length: 7 }, (_, index) => (
          <Skeleton
            pr={Spacing['inline.nano']}
            key={index}
            width="10%"
            testID={`test-skeleton-${index}`}
            borderRadius="sm"
            height="14px"
          />
        ))}
      </HStack>
      <HStack justifyContent="space-between" width="100%" space={Spacing['stack.quarck']}>
        {Array.from({ length: 7 }, (_, index) => (
          <Skeleton
            pr={Spacing['inline.nano']}
            key={index}
            width="10%"
            testID={`test-skeleton-${index}`}
            borderRadius="sm"
            height="14px"
          />
        ))}
      </HStack>
    </VStack>
  );

  return (
    <HStack
      marginBottom={Spacing['stack.xxs']}
      alignItems="center"
      height={104}
      borderRadius="md"
      backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}
      p={Spacing['stack.xxxs']}
      justifyContent="space-between"
      width="100%">
      {loading ? (
        skeletons
      ) : (
        <>
          <VStack space={Spacing['stack.quarck']}>
            <Text
              fontSize={Typography['fontsize.md']}
              color="neutral.black"
              fontWeight={Typography['fontweight.semibold']}>
              ID solicitação
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
              {sentOrderDetail?.managementFeeHashNormalized}
            </Text>
          </VStack>

          <VStack space={Spacing['stack.quarck']}>
            <Text
              fontSize={Typography['fontsize.md']}
              color="neutral.black"
              fontWeight={Typography['fontweight.semibold']}>
              Mês de competência
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
              {sentOrderDetail?.managementFeeMonthNormalized}
            </Text>
          </VStack>

          <VStack space={Spacing['stack.quarck']}>
            <Text
              fontSize={Typography['fontsize.md']}
              color="neutral.black"
              fontWeight={Typography['fontweight.semibold']}>
              Tipo
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
              {sentOrderDetail?.managementFeeTypeNormalized}
            </Text>
          </VStack>

          <VStack space={Spacing['stack.quarck']}>
            <Text
              fontSize={Typography['fontsize.md']}
              color="neutral.black"
              fontWeight={Typography['fontweight.semibold']}>
              Total de clientes
            </Text>
            <HStack alignItems="center" height={4}>
              <Icon name="People" size="xxs" testId="people-icon" color="neutral.dark" />
              <Text
                paddingLeft={Spacing['inline.quarck']}
                textAlign="center"
                alignSelf="center"
                fontSize={Typography['fontsize.md']}
                color="neutral.dark">
                {sentOrderDetail?.customerTotal}
              </Text>
            </HStack>
          </VStack>

          <VStack space={Spacing['stack.quarck']}>
            <Text
              fontSize={Typography['fontsize.md']}
              color="neutral.black"
              fontWeight={Typography['fontweight.semibold']}>
              Clientes validados
            </Text>
            <HStack alignItems="center" height={4}>
              <Icon
                name="Check"
                color={Color['feedback.success.default']}
                size="xxs"
                testId="check-icon"
                variant="rounded"
                padding="2"
                backgroundColor={Color['feedback.success.lightest']}
              />
              <Text
                paddingLeft={Spacing['inline.quarck']}
                fontSize={Typography['fontsize.md']}
                color="neutral.dark">
                {sentOrderDetail?.validCustomerTotal}
              </Text>
            </HStack>
          </VStack>

          {(sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Processed ||
            sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Cancelled) && (
            <VStack space={Spacing['stack.quarck']}>
              <Text
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                Clientes Inválidos
              </Text>
              <HStack alignItems="center" height={4}>
                <Icon
                  name="Close"
                  color={Color['feedback.error.default']}
                  size="xxs"
                  testId="close-icon"
                  variant="rounded"
                  backgroundColor={Color['feedback.error.lightest']}
                />
                <Text
                  paddingLeft={Spacing['inline.quarck']}
                  fontSize={Typography['fontsize.md']}
                  color="neutral.dark">
                  {sentOrderDetail?.invalidCustomerTotal}
                </Text>
              </HStack>
            </VStack>
          )}

          <VStack space={Spacing['stack.quarck']}>
            <Text
              fontSize={Typography['fontsize.md']}
              color="neutral.black"
              fontWeight={Typography['fontweight.semibold']}>
              Total a receber
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
              {sentOrderDetail?.totalAmountToReceiveNormalized}
            </Text>
          </VStack>

          {(sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Sent ||
            sentOrderDetail?.managementFeeStatusNormalized === ManagementFeeStatus.Scheduled) && (
            <VStack space={Spacing['stack.quarck']}>
              <Text
                fontSize={Typography['fontsize.md']}
                color="neutral.black"
                fontWeight={Typography['fontweight.semibold']}>
                Hora/data de Envio
              </Text>
              <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
                {sentOrderDetail?.managementFeeSentAtNormalized}
              </Text>
            </VStack>
          )}

          <MasterAccountField loading={loading} sentOrderDetail={sentOrderDetail} />
        </>
      )}
    </HStack>
  );
};
